module.exports = __webpack_public_path__ + "statics/img/jdtm_A.png";